var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 108,
    viewBox: "0 0 82 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_583_6881)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0028 100.115V97.7344L21.5905 89.6427V92.0236L58.0028 100.115ZM28.2541 88.7426L51.3392 93.8727L47.7161 84.6551L31.877 81.1353L28.2541 88.7426ZM73.5749 88.0206C75.4971 88.4478 77.0612 87.1933 77.0612 85.224V76.5734L2.53208 60.0114V68.662C2.53208 70.6313 4.09595 72.5808 6.01837 73.008L73.5749 88.0206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.207886 24.1595V68.1455C0.207886 71.4276 2.81439 74.6769 6.01837 75.3889L30.0121 80.7209L27.1396 86.7524L20.692 85.3196L19.2663 86.7454V93.888L60.327 103.013L61.7527 101.587V94.4442L55.3051 93.0114L52.4326 85.7032L73.5749 90.4015C75.1571 90.7531 76.5936 90.4212 77.6424 89.5998C77.7629 89.5055 77.8782 89.4047 77.9881 89.2978L79.6155 87.6619C80.3652 86.826 80.8111 85.6722 80.8111 84.3147V38.2842C80.8111 35.0021 78.2046 31.7528 75.0006 31.0408L66.7385 29.2048V33.3282L73.5749 34.8474C75.4971 35.2746 77.0612 37.2242 77.0612 39.1935V74.1925L2.53208 57.6305V24.676C2.53208 22.7067 4.09595 21.4522 6.01837 21.8794L14.1258 23.681V19.5576L7.44411 18.0727C5.68229 17.6812 4.10113 18.1372 3.03467 19.1728L2.94364 19.2639L1.63363 20.5747C0.745942 21.423 0.207886 22.6683 0.207886 24.1595ZM58.0028 100.115V97.7344L21.5905 89.6427V92.0236L58.0028 100.115ZM28.2541 88.7426L51.3392 93.8727L47.7161 84.6551L31.877 81.1353L28.2541 88.7426ZM73.5749 88.0206C75.4971 88.4478 77.0612 87.1933 77.0612 85.224V76.5734L2.53208 60.0114V68.662C2.53208 70.6313 4.09595 72.5808 6.01837 73.008L73.5749 88.0206Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7966 77.975C41.7189 78.4022 43.2829 77.1477 43.2829 75.1784C43.2829 73.2091 41.7189 71.2595 39.7966 70.8323C37.8742 70.4051 36.3103 71.6596 36.3103 73.6289C36.3103 75.5983 37.8742 77.5478 39.7966 77.975ZM39.7966 73.2132C40.4374 73.3556 40.9587 74.0054 40.9587 74.6619C40.9587 75.3184 40.4374 75.7365 39.7966 75.5941C39.1557 75.4517 38.6345 74.8019 38.6345 74.1454C38.6345 73.4889 39.1557 73.0708 39.7966 73.2132Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5097 7.03809L15.5516 15.0262L14.1259 16.4519V57.736L65.3129 69.1109L66.7386 67.6852V16.2001L25.5097 7.03809ZM23.4045 17.8178V12.3692L18.0857 16.6358L23.4045 17.8178ZM25.7241 20.7095L16.4455 18.6476V55.8753L62.9932 66.2192V19.4865L25.7241 11.2045V20.7095Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0456 25.6631L58.5231 31.3248V33.701L57.0974 35.1267L31.6199 29.465V27.0888L33.0456 25.6631Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7677 48.1558L49.2452 53.8174V56.1937L47.8194 57.6194L22.3419 51.9577V49.5815L23.7677 48.1558Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4063 24.6323L30.726 25.1478V27.524L29.3002 28.9498L26.9806 28.4343V26.058L28.4063 24.6323Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5642 54.3325L53.8838 54.848V57.2242L52.4581 58.65L50.1384 58.1345V55.7582L51.5642 54.3325Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2027 55.3638L58.5224 55.8792V58.2555L57.0966 59.6812L54.777 59.1657V56.7895L56.2027 55.3638Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.767 23.6011L26.0867 24.1166V26.4928L24.661 27.9185L22.3413 27.403V25.0268L23.767 23.6011Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7676 28.5127L58.5231 36.2355V38.6117L57.0974 40.0374L22.3419 32.3147V29.9384L23.7676 28.5127Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7676 33.4229L58.5231 41.1456V43.5219L57.0974 44.9476L22.3419 37.2248V34.8486L23.7676 33.4229Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7676 38.333L58.5231 46.0558V48.432L57.0974 49.8577L22.3419 42.135V39.7587L23.7676 38.333Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7676 43.2432L58.5231 50.9659V53.3422L57.0974 54.7679L22.3419 47.0451V44.6689L23.7676 43.2432Z",
    fill: "#4A0B82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_583_6881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.5743,
    height: 89.1483,
    fill: "white",
    transform: "matrix(0.976187 0.21693 0 1 0.207886 0.504883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.c8cd8d24716f627e2ab9c64e50a685fe.svg";
export { ForwardRef as ReactComponent };